<template>
    <page :title="'exportBestListTitle'" :textHeight="getWindowHeight">
        <template #pageContainer>
			<v-alert v-show="hasExported" type="success" class="mb-0">
			{{ExportMessage}}
			</v-alert>
			<v-alert v-show="hasExportError" type="error" class="mb-0">
			{{ErrorMessage}}
			</v-alert>
            <form>
				<v-row><v-col>
					Der gewünschte Export wird Ihnen per E-Mail im Anschluss zugestellt.
					Abhängig von der Auslastung unserer Systeme kann dieser Vorgang bis zu mehreren Stunden in Anspruch nehmen.
					Sollten Sie nach 12 Stunden keine E-Mail erhalten haben, bitte prüfen Sie ihr Spam-Postfach
					oder wenden Sie sich an den Seltec Support.
				</v-col></v-row>
				<v-row><v-col>
					<v-text-field outlined dense
						hide-details="auto"
						:label="$t('text.email')"
						v-model="jobmail"
						required>
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col>
					<v-text-field outlined dense
						hide-details="auto"
						:label="$t('text.jobpagesize')"
						v-model="jobpagesize"
						required>
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col>
					<v-text-field outlined dense
						hide-details="auto"
						:label="$t('text.jobyear')"
						v-model="jobyear"
						required>
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col>
					<v-autocomplete outlined dense
						hide-details="auto"
						class="mt-0 pt-0"
						v-model="jobenvironment"
						:items="environment"
						:label="$t('text.environment')">
					</v-autocomplete>
                </v-col></v-row>
				<v-row><v-col>
					<v-autocomplete outlined dense
						hide-details="auto"
						class="mt-0 pt-0"
						v-model="jobforeigners"
						:items="foreigners"
						:label="$t('text.foreignerfilter')">
					</v-autocomplete>
                </v-col></v-row>
            </form>
            <spinner :loading="loading || subLoading"></spinner>
        </template>
		<template #pageActions>
			<v-row><v-col>
				<v-btn
					class="mr-4"
					:loading="loading"
					:disabled="loading"
					@click="exportAndBack">
					{{ $t(`text.exportButton`) }}
				</v-btn>
				<v-btn
					:disabled="loading"
					class="mr-4"
					@click="back">
					{{ $t(`text.backButton`) }}
				</v-btn>
			</v-col></v-row>
		</template>
    </page>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import axios from 'axios';
import Page from '../general/Page.vue';
import Spinner from '../general/Spinner.vue';

import bestListActions from '../store/actions/bestList';
import namespace from '../store/namespace';

import modelState from '../mixins/modelState';

export default {
	name: 'ExportBestlist',
	components: {
		Page,
		Spinner,
	},
	mixins: [modelState],
	data() {
		return {
			environment: [{ text: this.$i18n.t('text.indoor'), value: 0 }, { text: this.$i18n.t('text.outdoor'), value: 1 }, { text: this.$i18n.t('text.all'), value: 2 }],
			foreigners: [{ text: this.$i18n.t('text.foreigners_noforeigner'), value: 1 }, { text: this.$i18n.t('text.foreigners_all'), value: 0 }, { text: this.$i18n.t('text.foreigners_onlyforeigner'), value: 2 }],
			jobmail: '',
			jobenvironment: 0,
			jobforeigners: 1,
			jobpagesize: 30,
			jobyear: 2021,
			ExportMessage: '',
			ErrorMessage: '',
			hasExported: false,
			hasExportError: false,
			name: '',
			loading: false,
			subLoading: false,
			id: this.$route.params.id || null,
		};
	},
	computed: {
		...mapGetters(['WindowSize']),
		...mapGetters(namespace.USER, ['User']),
		...mapGetters(namespace.BESTLIST, ['Links', 'Entities']),
		...mapGetters(namespace.ORGANIZATION, ['HasOrganization', 'ExternalId']),
		getWindowHeight() {
			if (this.adjusCombinationsMode || this.adjusValueMode) return `${this.WindowSize.y - 216}px`;
			return `${this.WindowSize.y - 276}px`;
		},
	},
	async mounted() {
		if (!this.Links.length) {
			await this.GET_PERFORMANCELIST_LINKS();
		}
		this.jobmail = this.User.email;
	},
	methods: {
		...mapActions(namespace.BESTLIST, [
			bestListActions.GET_BESTLIST_BY_ID,
			bestListActions.GET_PERFORMANCELIST_LINKS,
		]),
		async getPerformanceListLinks() {
			try {
				await this.GET_PERFORMANCELIST_LINKS();
			} catch (ex) {
				console.log(ex);
			}
		},
		async exportAndBack() {
			const url = `https://bestenliste.leichtathletik.de/api/external/startexport/${this.id}?mail=${this.jobmail}&pageSize=${this.jobpagesize}&year=${this.jobyear}&envi=${this.jobenvironment}&foreigners=${this.jobforeigners}`;
			axios({
				method: 'get',
				url,
			})
				.then((response) => {
					this.ExportMessage = '';
					this.ExportMessage = response.data;
					this.hasExportError = false;
					this.hasExported = true;
				})
				.catch((e) => {
					this.ErrorMessage = '';
					this.ErrorMessage = e.response.data;
					this.hasExported = false;
					this.hasExportError = true;
				});
		},
		back() {
			this.$router.push({
				name: 'bestlist',
			});
		},
		async getBestList() {
			this.loading = true;
			try {
				const bestList = await this.GET_BESTLIST_BY_ID(this.id);

				if (bestList) {
					this.name = bestList.name;
					this.organization.selected = bestList.regionalRestritionId;
				}
			} finally {
				this.loading = false;
			}
		},
	},
};
</script>
